import { map } from 'lodash';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import Contact from '../../../shared/model/contact/Contact';
import { filterByProp } from '../../../shared/util/collection';
import TitleComponent from '../global/Title';

const Contacts = ({ contacts, ids }) => {
  const contactsFiltered = useMemo(() => filterByProp(contacts, ids, 'id', 'name'), [
    contacts,
    ids
  ]);
  if (!contactsFiltered) {
    return null;
  }
  return map(contactsFiltered, (contact) => (
    <TitleComponent
      key={contact.id}
      avatar={contact.getAvatar()}
      title={contact.getName()}
      trivial
    />
  ));
};

Contacts.propTypes = {
  contacts: PropTypes.arrayOf(PropTypes.instanceOf(Contact)).isRequired,
  ids: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string])
};

Contacts.defaultProps = {
  contacts: [],
  ids: []
};

export default Contacts;
